/**
 * Team Members Section — thin wrapper around TeamManagementTab.
 */

import { useCanWrite } from '@/hooks/usePermissions';
import { useViewHealthMarker } from '@/lib/view-health';

import { TeamManagementTab } from '../../profile/components/TeamManagementTab';

export function TeamMembersSection() {
  useViewHealthMarker('settings-section-ready');
  // A read-only seat can look at the team (it is where "See who manages
  // seats" lands) but manages nothing — say so instead of promising it.
  const canWrite = useCanWrite();
  return (
    <div className='space-y-8'>
      <div>
        <h2 className='text-lg font-semibold text-fg-primary'>Team members</h2>
        <p className='text-sm text-fg-tertiary mt-0.5'>
          {canWrite
            ? 'Manage team members, roles, and invitations.'
            : 'Your team, their roles, and who manages seats.'}
        </p>
      </div>
      <div>
        <TeamManagementTab />
      </div>
    </div>
  );
}
